<template>

    <div class="input-group">

        <button class="btn btn-lg btn-dark text-white px-2" 
                type="button" 
                @click="decreseQuantity" 
                :disabled="quantity <= minQuantity">
            <i class="bi bi-dash"></i>
        </button>

        <input type="number" 
               class="form-control text-center quantity-input"
               ref="quantity" 
               v-bind="$attrs" 
               v-model="quantity" 
               @input="$emit('input', $event.target.value)" 
               :step="interval" 
               :min="minQuantity" 
               :max="maxQuantity"
               />

        <button class="btn btn-lg btn-dark text-white px-2" 
                type="button" 
                @click="increaseQuantity" 
                :disabled="quantity >= maxQuantity">
            <i class="bi bi-plus"></i>
        </button>

    </div>

</template>


<script>
    export default {
        inheritAttrs: false,
        props: [
            'min',
            'max',
            'interval',
            'value',
        ],
        data() {
            return {
                quantity: this.value,
            }
        },
        // Use computed properties to handle null values from the props
        computed: {
            minQuantity() {
                return this.min || 1;
            },
            maxQuantity() {
                // If no max quantity is set, allow to order 100x the min order quantity by default
                return this.max || this.minQuantity * 100;
            }
        },
        watch: {
            quantity(quantity) {
                this.$emit('input', quantity)
            },
        },
        methods: {
            decreseQuantity() {
                this.quantity = parseInt(this.quantity) > parseInt(this.minQuantity) ? parseInt(this.quantity) - this.interval : parseInt(this.minQuantity);
                console.log('Decreased quantity to', this.quantity);
            },
            increaseQuantity() {
                this.quantity = parseInt(this.quantity) < parseInt(this.maxQuantity) ? parseInt(this.quantity) + this.interval : parseInt(this.maxQuantity);
                console.log('Increased quantity to', this.quantity);
            },
        },
    }
</script>